import * as React from 'react'
import { Dropdown, Menu, Checkbox, Divider, Button, Icon } from 'antd'

interface Props {
  wrapperClassName?: string
  mappedColumns: Map<string, boolean>
  checkedColumnIndices: string[]
  setMappedColumns: (mappedColumns: Map<string, boolean>) => void
}

export const ONDropdown = (props: Props) => {
  const { wrapperClassName, mappedColumns, checkedColumnIndices, setMappedColumns } = props
  const allChecked = checkedColumnIndices.length === mappedColumns.size

  return (
    <Dropdown
      trigger={['click']}
      className={wrapperClassName}
      overlay={
        <Menu>
          <Menu.Item disabled style={{ padding: 0 }}>
            <Checkbox
              checked={allChecked}
              className='w-100'
              style={{ padding: '5px 12px' }}
              onChange={(e) => {
                ;[...mappedColumns.keys()].forEach((key) => {
                  mappedColumns.set(key, e.target.checked)
                })

                setMappedColumns(mappedColumns)

                e.stopPropagation()
              }}
            >
              {`${allChecked ? 'Unselect' : 'Select'} all`}
            </Checkbox>
          </Menu.Item>

          <Divider className='m-0' />

          {[...mappedColumns.keys()].map((columnDataIndex) => {
            const checked = !!mappedColumns.get(columnDataIndex)

            return (
              <Menu.Item key={columnDataIndex} disabled style={{ padding: 0 }}>
                <Checkbox
                  checked={checked}
                  className='w-100'
                  style={{ padding: '5px 12px' }}
                  onChange={(e) => {
                    mappedColumns.set(columnDataIndex, e.target.checked)

                    setMappedColumns(mappedColumns)

                    e.stopPropagation()
                  }}
                >
                  {columnDataIndex}
                </Checkbox>
              </Menu.Item>
            )
          })}
        </Menu>
      }
    >
      <Button>
        <span>
          {allChecked
            ? 'All columns'
            : `${checkedColumnIndices.length} column${checkedColumnIndices.length > 1 ? 's' : ''}`}
        </span>
        <Icon type='down' />
      </Button>
    </Dropdown>
  )
}
